<template>
  <div :class="!$vuetify.breakpoint.xsOnly ? 'pa-7' : 'pt-4'">
    <div class="d-flex justify-space-between mb-5">
      <div class="d-flex align-center">
        <div>
          <v-btn @click="$router.go(-1)" class="left-arrow" icon>
            <v-icon>mdi-arrow-top-left</v-icon>
          </v-btn>
        </div>
        <div class="ml-2">
          <span class="header">Webinar</span>
        </div>
      </div>
      <div :class="$vuetify.breakpoint.xsOnly ? 'mr-3' : ''">
        <v-btn
          :disabled="!Authentecated()"
          color="primary"
          @click="openWebinar.flag = true"
          class="add-webinar"
          height="42px"
          >+ Add Webinar</v-btn
        >
      </div>
    </div>
    <WebinarsList class="mb-15" />
    <AddWebinar :openWebinar="openWebinar" />
  </div>
</template>

<script>
import WebinarsList from "@/components/Trending/Webinars/WebinarsList.vue";
import AddWebinar from "@/components/Trending/Webinars/AddWebinar.vue";
import { isAuthenticated } from "@/common/commonFunctions.js";

export default {
  name: "webinarsList",
  components: { WebinarsList, AddWebinar },
  data() {
    return {
      Authentecated: isAuthenticated,
      openWebinar: {
        flag: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .add-webinar {
    width: 120px !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    line-height: 17.76px !important;
    text-align: center;
  }
}
.left-arrow {
  transform: rotate(-45deg);
}
.header {
  color: rgba(0, 0, 0, 0.87);
  font-family: Avenir;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.add-webinar {
  width: 163px;
  height: 42px;
  border-radius: 6px;

  font-family: Avenir;
  font-size: 15px;
  font-weight: 500;
  line-height: 20.49px;
  text-align: center;
  text-transform: capitalize;
}
</style>
